import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { colors } from '@/lib/analytics/colors';
import { KPI_VALUE_PERCENT } from '@/hooks/format/useFormatKpiValue';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerViewsRate: KpiType<typeof MediaViewerKpiLoader> = {
    name: 'kpi.tiktok.views_rate',
    id: 'view_rate',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    mergedData: true,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
